var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12.444,
    viewBox: "0 0 14 12.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Details_-_Default",
    "data-name": "Details - Default",
    d: "M4.5,6l7,12.444L18.5,6ZM7.129,7.556h8.75L11.5,15.333Z",
    transform: "translate(-4.5 -6)",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsDefault);
export default __webpack_public_path__ + "static/media/Details - Default.9bae7a27d1cc1e7dbb33422680b14686.svg";
export { ForwardRef as ReactComponent };